<template>
    <div :ref="stepName" style="position:relative">
        <div class="form-header">
            <!--<p>Pagamento tramite conto corrente bancario:</p>-->
            <!--<p><span>Prova Altroconsumo GRATIS per 15&nbsp;giorni + dopo la prova solo 2€ per i primi 2 mesi</span></p>-->
        </div>
        <IbanForm></IbanForm>
    </div>
</template>

<script>
import mixin from "../../../travel_step_mixin";
import IbanForm from "./IbanForm";
import animation_engine_mixin from "../../../animation_engine_mixin";
import animation_step_style_mixin from "../../../animation_step_style_mixin";

export default {
    components: { IbanForm },
    mixins: [mixin,  animation_engine_mixin, animation_step_style_mixin],
}
</script>
